<mat-card>
    <mat-card-header>
        <mat-icon mat-card-avatar *ngIf="icon">{{ icon }}</mat-icon>
        <mat-card-title *ngIf="title">{{ title }}</mat-card-title>
        <mat-card-subtitle *ngIf="message">{{ message }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions class="view-message-actions">
        <ng-content select="[pvMessageAction]"></ng-content>
    </mat-card-actions>
</mat-card>